import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import CustomCursor from "./components/CustomCursor";
import AnimatedPage from "./components/AnimatedPage";
import Brands from "./pages/Brands";
import Portraits from "./subpages/Portraits";
import Tasty from "./subpages/Tasty";
import Documentary from "./subpages/Documentary";
import Studio from "./subpages/Studio";
import ScrollToTop from "./components/ScrollToTop";
import Video from "./pages/Video";
import Visa from "./subpages/brands/Visa";
import Amazon from "./subpages/brands/Amazon";
import Audi from "./subpages/brands/Audi";
import Bacardi from "./subpages/brands/Bacardi";
import Buick from "./subpages/brands/Buick";
import BK from "./subpages/brands/Burgerking";
import Emptyrooms from "./subpages/brands/Emptyrooms";
import Garnier from "./subpages/brands/Garnier";
import Jumex from "./subpages/brands/Jumex";
import Kermato from "./subpages/brands/Kermato";
import Larocheposay from "./subpages/brands/Larocheposay";
import Luppa from "./subpages/brands/Luppa";
import Netflix from "./subpages/brands/Netflix";
import Quaker from "./subpages/brands/Quaker";
import Real from "./subpages/brands/Real";
import Spotify from "./subpages/brands/Spotify";
import Unicofresco from "./subpages/brands/Unicofresco";
import BBVA from "./subpages/brands/BBVA";
import PreVideo from "./pages/PreVideo";
import AddVideo from "./pages/Adds-Video";
import Esponjabon from "./subpages/brands/Esponjabon";
import Edding from "./subpages/brands/Edding";
import Laveta from "./subpages/brands/Laveta";
import Puntomaq from "./subpages/brands/Puntomaq";
import Balance from "./subpages/brands/Balance";
import Dandy from "./subpages/brands/Dandy";
import Farmacias from "./subpages/brands/Farmacias";
import Generalli from "./subpages/brands/Generalli";
import GNP from "./subpages/brands/Government";
import PUBLICO from "./subpages/brands/Publico";

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <div className="container">
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <AnimatedPage>
                <Home />
              </AnimatedPage>
            }
          />
          <Route
            path="/advertising"
            element={
              <AnimatedPage>
                <Brands />
              </AnimatedPage>
            }
          />
          <Route
            path="/photography"
            element={
              <AnimatedPage>
                <Gallery />
              </AnimatedPage>
            }
          />
          <Route
            path="/portraits"
            element={
              <AnimatedPage>
                <Portraits />
              </AnimatedPage>
            }
          />
          <Route
            path="/tasty"
            element={
              <AnimatedPage>
                <Tasty />
              </AnimatedPage>
            }
          />
          <Route
            path="/documentary"
            element={
              <AnimatedPage>
                <Documentary />
              </AnimatedPage>
            }
          />
          <Route
            path="/studio"
            element={
              <AnimatedPage>
                <Studio />
              </AnimatedPage>
            }
          />
          <Route
            path="/contact"
            element={
              <AnimatedPage>
                <Contact />
              </AnimatedPage>
            }
          />
          <Route
            path="/video"
            element={
              <AnimatedPage>
                <Video />
              </AnimatedPage>
            }
          />
          <Route
            path="/visa"
            element={
              <AnimatedPage>
                <Visa />
              </AnimatedPage>
            }
          />
          <Route
            path="/amazon"
            element={
              <AnimatedPage>
                <Amazon />
              </AnimatedPage>
            }
          />
          <Route
            path="/audi"
            element={
              <AnimatedPage>
                <Audi />
              </AnimatedPage>
            }
          />
          <Route
            path="/bacardi"
            element={
              <AnimatedPage>
                <Bacardi />
              </AnimatedPage>
            }
          />
          <Route
            path="/buick"
            element={
              <AnimatedPage>
                <Buick />
              </AnimatedPage>
            }
          />
          <Route
            path="/burgerking"
            element={
              <AnimatedPage>
                <BK />
              </AnimatedPage>
            }
          />
          <Route
            path="/emptyrooms"
            element={
              <AnimatedPage>
                <Emptyrooms />
              </AnimatedPage>
            }
          />
          <Route
            path="/garnier"
            element={
              <AnimatedPage>
                <Garnier />
              </AnimatedPage>
            }
          />
          <Route
            path="/jumex"
            element={
              <AnimatedPage>
                <Jumex />
              </AnimatedPage>
            }
          />
          <Route
            path="/kermato"
            element={
              <AnimatedPage>
                <Kermato />
              </AnimatedPage>
            }
          />
          <Route
            path="/larocheposay"
            element={
              <AnimatedPage>
                <Larocheposay />
              </AnimatedPage>
            }
          />
          <Route
            path="/luppa"
            element={
              <AnimatedPage>
                <Luppa />
              </AnimatedPage>
            }
          />
          <Route
            path="/netflix"
            element={
              <AnimatedPage>
                <Netflix />
              </AnimatedPage>
            }
          />
          <Route
            path="/quaker"
            element={
              <AnimatedPage>
                <Quaker />
              </AnimatedPage>
            }
          />
          <Route
            path="/real"
            element={
              <AnimatedPage>
                <Real />
              </AnimatedPage>
            }
          />
          <Route
            path="/spotify"
            element={
              <AnimatedPage>
                <Spotify />
              </AnimatedPage>
            }
          />
          <Route
            path="/unico-fresco"
            element={
              <AnimatedPage>
                <Unicofresco />
              </AnimatedPage>
            }
          />
          <Route
            path="/bbva"
            element={
              <AnimatedPage>
                <BBVA />
              </AnimatedPage>
            }
          />
          <Route
            path="/adds-or-clips"
            element={
              <AnimatedPage>
                <PreVideo />
              </AnimatedPage>
            }
          />
          <Route
            path="/adds-video"
            element={
              <AnimatedPage>
                <AddVideo />
              </AnimatedPage>
            }
          />
          <Route
            path="/esponjabon"
            element={
              <AnimatedPage>
                <Esponjabon />
              </AnimatedPage>
            }
          />
          <Route
            path="/edding"
            element={
              <AnimatedPage>
                <Edding />
              </AnimatedPage>
            }
          />
          <Route
            path="/laveta"
            element={
              <AnimatedPage>
                <Laveta />
              </AnimatedPage>
            }
          />
          <Route
            path="/punto-maq"
            element={
              <AnimatedPage>
                <Puntomaq />
              </AnimatedPage>
            }
          />
          <Route
            path="/balance"
            element={
              <AnimatedPage>
                <Balance />
              </AnimatedPage>
            }
          />
          <Route
            path="/dandy"
            element={
              <AnimatedPage>
                <Dandy />
              </AnimatedPage>
            }
          />
          <Route
            path="/farmacias"
            element={
              <AnimatedPage>
                <Farmacias />
              </AnimatedPage>
            }
          />
          <Route
            path="/generali"
            element={
              <AnimatedPage>
                <Generalli />
              </AnimatedPage>
            }
          />
          <Route
            path="/gnp"
            element={
              <AnimatedPage>
                <GNP />
              </AnimatedPage>
            }
          />
          <Route
            path="/publico"
            element={
              <AnimatedPage>
                <PUBLICO />
              </AnimatedPage>
            }
          />
        </Routes>
      </AnimatePresence>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <CustomCursor />
      <Header />
      <AnimatedRoutes />
      <Footer />
    </Router>
  );
};

export default App;
